import { RefreshCw, Wifi, WifiOff } from "lucide-react";
import { useOffline } from "../context/OfflineContext";

export default function OfflineBanner() {
  const {
    isOffline,
    showReconnected,
    pendingOfflineSales,
    isSyncingOfflineSales,
    syncOfflineSales,
  } = useOffline();

  const isReconnected = !isOffline && showReconnected;
  const showPendingOnly = !isOffline && !showReconnected && pendingOfflineSales > 0;

  if (!isOffline && !showReconnected && pendingOfflineSales === 0) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed inset-x-0 top-0 z-[110] flex h-10 items-center justify-center gap-3 px-4 text-sm font-medium text-white shadow-md ${
        isReconnected
          ? "bg-emerald-600"
          : showPendingOnly
            ? "bg-sky-700"
            : "bg-amber-600"
      }`}
    >
      {isReconnected ? (
        <>
          <Wifi className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span>Back online — syncing saved sales and latest data.</span>
        </>
      ) : showPendingOnly ? (
        <>
          <span>
            {pendingOfflineSales} offline sale
            {pendingOfflineSales === 1 ? "" : "s"} waiting to sync.
          </span>
          <button
            type="button"
            onClick={() => void syncOfflineSales()}
            disabled={isSyncingOfflineSales}
            className="inline-flex items-center gap-1 rounded-md border border-white/30 px-2 py-0.5 text-xs font-semibold hover:bg-white/10 disabled:opacity-60"
          >
            <RefreshCw
              className={`h-3.5 w-3.5 ${isSyncingOfflineSales ? "animate-spin" : ""}`}
            />
            Retry
          </button>
        </>
      ) : (
        <>
          <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span>
            You&apos;re offline — cash sales can be saved and will sync later.
            {pendingOfflineSales > 0
              ? ` ${pendingOfflineSales} pending.`
              : ""}
          </span>
        </>
      )}
    </div>
  );
}
